import { ContributionGraph } from '../../contribution-graph'
import type { DailyActivity } from '@lens/types/claude'

interface Props {
  data: DailyActivity[]
}

/**
 * Lens "Activity Calendar" — a thin wrapper over the shared
 * <ContributionGraph> that maps Claude session activity to daily message
 * counts. The reusable graph lives at `@excellent/ui` (ContributionGraph).
 */
export function ActivityHeatmap({ data }: Props) {
  return (
    <ContributionGraph
      data={data.map((d) => ({ date: d.date, count: d.messageCount }))}
      unitLabel="messages"
    />
  )
}
